import Panel from 'bitmovin-web-ui/src/components/generic/panel/index';
import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import {SalesDemo} from '../../../logic/api/frontendService/entities';
import {AppRoutePathFunction} from '../../../logic/routes';
import SalesDemoIconPathRegistry from '../../../logic/salesDemoIconPathRegistry';
import {Link, pxToEm} from '../../globalStyles';

//#region Styled Components

const StyledPanel = styled(Panel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${baseVariables.colors.lightBlueGray};
  width: 100%;
  height: 100%;
  min-height: ${pxToEm(118)}em;
  padding: 0 ${pxToEm(10)}em ${pxToEm(10)}em;
  border: 1px solid ${baseVariables.colors.mediumBlueGray};
  border-radius: ${baseVariables.sizes.borderRadius};
`;

const StyledImg = styled.img`
  height: ${pxToEm(54)}em;
  width: ${pxToEm(54)}em;
  filter: invert(0.5) sepia(1) saturate(5) hue-rotate(175deg);
  margin-bottom: ${pxToEm(10)}em;
`;

const StyledTitleDiv = styled.div`
  font-size: ${pxToEm(16)}em;
  font-weight: bold;
  text-align: center;
`;

//#endregion

interface Props {
  salesDemo: SalesDemo;
}

const SalesDemoTileLink: React.FunctionComponent<Props> = props => {
  return (
    <Link to={AppRoutePathFunction.DemoDetail({demoId: props.salesDemo.id})}>
      <StyledPanel>
        <StyledImg src={SalesDemoIconPathRegistry.getIconPath(props.salesDemo.path)} alt="" />
        <StyledTitleDiv>{props.salesDemo.name}</StyledTitleDiv>
      </StyledPanel>
    </Link>
  );
};

export default SalesDemoTileLink;
